import { cn } from '@/lib/utils'

import { LevelPlayStartBadge } from './LevelPlayStartBadge'
import { LevelPlayStartRewards } from './LevelPlayStartRewards'

export interface LevelPlayStartCardJourneyProps {
  name: string
  challengeCount: number
  pointReward?: number | null
  coinReward?: number | null
  className?: string
}

const journeyFocusHint = (challengeCount: number) =>
  `Complete ${challengeCount} desafio${challengeCount === 1 ? '' : 's'} com atenção! Essa jornada exige foco e estratégia.`

export const LevelPlayStartCardJourney = ({
  name,
  challengeCount,
  pointReward,
  coinReward,
  className
}: LevelPlayStartCardJourneyProps) => (
  <div
    className={cn(
      'w-full max-w-[400px] rounded-xl border border-gray-200 bg-white p-3 shadow-sm',
      className
    )}
  >
    <LevelPlayStartBadge kind="journey" size="sm" className="mb-2" />

    <div className="flex flex-col gap-1">
      <span className="text-sm font-bold leading-snug text-[#1e2139]">
        {name}
      </span>
      <p className="m-0 text-sm leading-snug text-gray-700">
        {journeyFocusHint(challengeCount)}
      </p>
    </div>

    <LevelPlayStartRewards
      pointReward={pointReward}
      coinReward={coinReward}
      className="mt-3"
    />
  </div>
)
